export default {
  title: "Tukaj ni ničesar",
  subtitle: "Ups ...",
  content: "Ta stran ne obstaja ali pa je bila premaknjena",
  go_back: "Vrni se tja, od koder si prišel",
  go_home: "Nazaj na domačo stran"
}
